import _ from 'lodash'
import { createSelector } from 'reselect'

import { RootState } from '../../reducers'
import { containsAtLeastOneError } from '../../features/ssml'
import { SsmlSlice, ValidatedEntityId } from './ssmlSlice'

export type SsmlValidationResultsGroup = keyof SsmlSlice['validationResults']

const ssmlSliceSelector = (state: RootState) => state.ssml

export function getValidationResults(section: SsmlValidationResultsGroup) {
  return function getValidationResults(state: RootState) {
    return ssmlSliceSelector(state).validationResults[section]
  }
}

export function ssmlValidationResultForIdSelector(
  section: SsmlValidationResultsGroup,
  id: ValidatedEntityId
) {
  return function ssmlValidationResultForStepIdSelector(state: RootState) {
    return getValidationResults(section)(state)[id]
  }
}

export const validationResultsWithErrorSelector = _.memoize((section: SsmlValidationResultsGroup) =>
  createSelector(
    getValidationResults(section), // I <3 PRETTIER
    results => {
      const entriesWithErrors = Object.entries(results).filter(([key, val]) =>
        containsAtLeastOneError(val!)
      )

      return Object.fromEntries(entriesWithErrors)
    }
  )
)

export const isThereSsmlValidationErrorSelector = _.memoize((section: SsmlValidationResultsGroup) =>
  createSelector(
    validationResultsWithErrorSelector(section),
    resultsWithError => !!Object.keys(resultsWithError).length
  )
)

export function shouldHideSsmlSelector(state: RootState): boolean {
  return state.ssml.shouldHideSsml
}
